'use client';

import { usePathname } from 'next/navigation';
import Header from '@/components/custom/home/Header';
import Footer from '@/components/custom/home/Footer';
import { Toaster } from "@/components/ui/toaster"

interface ConditionalLayoutProps {
    children: React.ReactNode;
}

export default function ConditionalLayout({ children }: ConditionalLayoutProps) {
    const pathname = usePathname();

    // Check if current route is an auth page
    const isAuthPage = pathname === '/login/' || pathname === '/signup/' || pathname === '/login' || pathname === '/signup' || pathname === '/forgot-password' || pathname === '/reset-password';

    // Check if current route is an admin page
    const isAdminPage = pathname?.startsWith('/admin');

    if (isAuthPage || isAdminPage) {
        return <>{children}<Toaster /></>;
    }

    return (
        <>
            <Header />
            {children}
            <Footer />
            <Toaster />
        </>
    );
}
